// Same-origin relative paths on purpose: the API is a Managed Function on the
// same Static Web App, so there is no host to configure per environment.
function availabilityUrl(slug) {
  return `/api/vehicles/${encodeURIComponent(slug)}/availability`;
}

function reservationsUrl(slug) {
  return `/api/vehicles/${encodeURIComponent(slug)}/reservations`;
}

function termsUrl() {
  return '/api/terms';
}

async function fetchAvailability(slug) {
  const response = await fetch(availabilityUrl(slug));

  if (!response.ok) {
    throw new Error(`Could not load availability (${response.status})`);
  }

  const body = await response.json();
  return body.unavailableDates || [];
}

async function fetchCurrentTerms() {
  const response = await fetch(termsUrl());

  if (!response.ok) {
    throw new Error(`Could not load Terms and Conditions (${response.status})`);
  }

  return response.json();
}

async function submitReservation(slug, request) {
  const response = await fetch(reservationsUrl(slug), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request),
  });

  const body = await response.json().catch(() => ({}));

  if (response.ok) {
    return { outcome: 'pending', reservationId: body.reservationId };
  }

  if (response.status === 400) {
    return { outcome: 'invalid', errors: body.errors || ['That request was not valid.'] };
  }

  if (response.status === 409) {
    return { outcome: 'unavailable', errors: [body.error] };
  }

  return {
    outcome: 'error',
    errors: [body.error || 'Something went wrong. Please try again, or contact us directly.'],
  };
}

export { fetchAvailability, fetchCurrentTerms, submitReservation };
